<template>
  <div class="notification-container" v-rect-loading="loading">
    <div class="title-container">
      {{ $t(`${i18nPrefix}.label.notification`) }}
    </div>
    <div class="list-container">
      <div
        class="list-item"
        v-for="(item, index) in notificationList"
        :key="index"
      >
        <div class="info-container">
          <div class="title" @click="handelToDetail(item)">{{ item.title }}</div>
          <div class="time">{{ item.time }}</div>
        </div>
        <div class="content-container">
          <div class="content">{{ item.content }}</div>
          <div class="status" :class="item.status === 1 && 'unread'">{{ $t(`${i18nPrefix}.label.${item.status === 0 ? 'read' : 'unread'}`) }}</div>
        </div>
      </div>
      <el-pagination
        class="pagination"
        background
        layout="total, sizes, prev, pager, next"
        :current-page="pageSetting.pageNum"
        :page-sizes="[10, 20, 50]"
        :page-size="pageSetting.pageSize"
        :total="pageSetting.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
// import _ from 'lodash'
import { mapActions } from 'vuex'

export default {
  components: {
  },
  data () {
    return {
      i18nPrefix: 'admin.notification',
      loading: false,
      notificationList: [],
      pageSetting: {
        pageSize: 10,
        pageNum: 1,
        total: 0
      }
    }
  },
  computed: {
  },
  created () {
    this.initList()
  },
  methods: {
    ...mapActions('notification', ['getNotificationList']),
    async initList () {
      this.loading = true
      try {
        const resp = await this.getNotificationList({
          page_size: this.pageSetting.pageSize,
          page: this.pageSetting.pageNum
        })
        if (resp) {
          this.notificationList = resp.results
          this.pageSetting.total = resp.count
        }
      } finally {
        this.loading = false
      }
    },
    handleSizeChange (val) {
      this.pageSetting.pageSize = val
      this.pageSetting.pageNum = 1
      this.initList()
    },
    handleCurrentChange (val) {
      this.pageSetting.pageNum = val
      this.initList()
    },
    handelToDetail (item) {
      this.$router.push(`/v-admin/notification/detail/${item.id}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.notification-container {
  width: 100%;
  min-height: 100%;
  background: #FFFFFF;
  min-width: 1320px;
  padding: 20px;
  overflow: auto;

  .title-container {
    line-height: 40px;
    text-align: center;
    font-size: 24px;
    padding-bottom: 10px;
    margin: 0 auto;
  }

  .list-container {
    border-top: 2px solid #cccccc;
    display: flex;
    margin: auto;
    padding-top: 20px;
    align-items: center;
    width: 900px;
    flex-direction: column;

    .list-item {
      padding: 15px 17px;
      background-color: #f9f9f9;
      border: 1px solid #ddd;
      margin-bottom: 5px;
      width: 900px;

      .info-container {
        > div {
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .title {
          width: 85%;
          font-size: 20px;
          cursor: pointer;
          color: #0096cc;
        }

        .time {
          width: 15%;
          font-size: 13px;
          line-height: 29px;
          text-align: center;
        }
      }

      .content-container {
        > div {
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .content {
          width: 85%;
          font-size: 15px;
          line-height: 24px;
        }
        .status {
          width: 15%;
          font-size: 13px;
          line-height: 24px;
          text-align: center;

          &.unread {
            color: #ff975f;
          }
        }
      }
    }

    .pagination {
      margin-top: 10px;
      width: 100%;
      text-align: right;
    }
  }
}
</style>
